import AutomatedInsuranceRunStatus from './AutomatedInsuranceRunStatus';

export type { AutomatedInsuranceRunStatusState } from './types';
export default AutomatedInsuranceRunStatus;
